module.exports = __webpack_public_path__ + "img/time.901e506a.svg";